<template>
  <div class="bind-email" :class="$platformClass">
    <Content class="quession-title" :class="$platformClass" type="passportTips">
      {{ languages.bindEmailTips }}
    </Content>
    <form class="quession-form">
      <Editor
        v-model="newEmail"
        :class="$platformClass"
        editorClass="editor email-send"
        class="editor-wrapper email-send relative"
        :type="$isOmni ? 'emailEditor' : 'passportAccountEditor'"
        :placeholder="languages.enterEmailTips"
      >
        <AcountDownBtn
          class="sendEmailBtn"
          @countDown="sendVrCode2Email()"
          :countTime="60"
        >
          {{ languages.send }}
        </AcountDownBtn>
      </Editor>
      <Editor
        v-model="code"
        editorClass="editor email-send"
        class="editor-wrapper relative"
        :type="$isOmni ? 'emailEditor' : 'passportAccountEditor'"
        :placeholder="languages.enterEmailVrfcationTips"
      ></Editor>
      <!-- <Agreements v-on:changeAgreeTerms="selectTerm"></Agreements> -->
      <Block
        tagName="label"
        type="editorWrapper"
        class="agree-wrapper email-send-btn"
        :class="$platformClass"
      >
        <Button
          class="btn account-setting-submit"
          :type="$isOmni ? 'lightfill' : 'fillLight'"
          data-asyncbtn
          @click="submit"
          v-touchActive
        >
          <Icon type="commonBtnLeft"></Icon>
          <Icon type="commonBtnRight"></Icon>
          {{ languages.submit }}
        </Button>
      </Block>
    </form>
  </div>
</template>
<script>
// import Agreements from "./Agreements";
import AcountDownBtn from './AcountDownBtn';
import {
  BIND_EMAIL_REF,
  UPDATE_EMAIL_REF,
} from '../../store/passport/accountSetting';
export const FORM_TYPE_BIND_EMIAL = 'bindEmail';
export const FORM_TYPE_UPDATE_EMAIL = 'updateEmail';
export default {
  props: ['languages', 'email', 'ckcode', 'type'],
  data() {
    return {
      newEmail: this.email,
      code: this.ckcode,
    };
  },
  components: { AcountDownBtn },
  computed: {
    ref() {
      let ref = '';
      if (this.type === FORM_TYPE_UPDATE_EMAIL) {
        ref = UPDATE_EMAIL_REF;
      } else {
        ref = BIND_EMAIL_REF;
      }
      return ref;
    },
  },
  methods: {
    submit() {
      this.$emit('submit', {
        ref: this.ref,
        email: this.newEmail.trim(),
        ckcode: this.code,
      });
    },
    sendVrCode2Email() {
      this.$emit('sendVrCode2Email', {
        ref: this.ref,
        email: this.newEmail.trim(),
      });
    },
    selectTerm() {
      this.$emit('selectTerm');
    },
  },
  mounted() {
    this.$emit('selectTerm', true);
  },
};
</script>
